<div class="page-header">
  <div class="header-start">
    <h3 class="title">
      <ng-container *ngIf="operation == 'view'">View Role</ng-container>
      <ng-container *ngIf="operation == 'edit'">Edit Role</ng-container>
      <ng-container *ngIf="operation != 'edit' && operation != 'view'">Add Role</ng-container>
    </h3>
  </div>
  <div class="header-end">

  </div>
</div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb breadcrumb-sm d-flex justify-content-start">
    <li class="breadcrumb-item"><a class="link" (click)="navigateToProfilesList()">Role</a></li>
    <li class="breadcrumb-item active"><span>{{title == 'edit'? 'Edit Role': operation == 'view'? 'View Role': 'Add Role'}}</span></li>
  </ol>
</nav>

<spinner [id]="'role-resource-data'" [show]='loading || (resourceApiInProgress && currentTab === "resources")'></spinner>
<mat-stepper #stepper [selectedIndex]="currentTabIndex" color="primary" [linear]="operation != 'edit' && operation != 'view'" (selectionChange)="onToggleTab($event)">
  <mat-step label="Role Info" [stepControl]="nextStepValidForm">
    <form #f="ngForm" autocomplete="off">
      <div class="row g-3">
        <div class="col-sm-6 col-xl-4">
          <div class="form-group">
            <form #roleNameFormRef="ngForm" [formGroup]="roleNameForm">
              <mat-form-field class="w-100">
                <mat-label>Role Name</mat-label>
                <input matInput *ngIf="operation !== 'view'" type="text" (input)="inputHasOnlyAlphabets($event)"
                  (keypress)="onlyAlphabet($event)" (keydown)="space($event)" formControlName="roleName" name="name" id="name" placeholder="Role Name" required>
                <mat-error *ngIf="isNameTouched && isFormNotValid">
                  * Role Name should not be empty
                </mat-error>
                <input matInput *ngIf="operation === 'view'" readonly formControlName="roleName" [value]="profileData.firstName">
              </mat-form-field>
            </form>
          </div>
        </div>

        <div class="col-sm-6 col-xl-4">
          <div class="form-group">
            <form #roleApplicationNameFormRef="ngForm" [formGroup]="roleApplicationNameForm">
              <mat-form-field class="w-100">
                <mat-label>Application Name</mat-label>
                <mat-select *ngIf="operation !== 'view'" formControlName="applicationName"  name="application" (selectionChange)="applicationValueChanged($event)"
                  id="application"  required>
                  <mat-option *ngFor="let item of applicationList; let i = index" [value]="item.applicationId">
                    {{item.applicationName}}
                  </mat-option>
                </mat-select>
                <input matInput *ngIf="operation === 'view'" readonly  [value]="profileData.applicationName">
              </mat-form-field>
            </form>
          </div>
        </div>
        <div class="col-sm-6 col-xl-4">

          <div class="mat-mdc-form-field-ro">
            <div class="mdc-floating-label">
              Customer
            </div>
            <div class="mat-mdc-text-field-wrapper"
              *ngIf="userMetaInfo && userMetaInfo['customerId'] && userMetaInfo['customerName'] else superadmin">
              {{ userMetaInfo['customerName'] }}
            </div>
            <ng-template #superadmin>
              <div class="mat-mdc-text-field-wrapper">
                {{ profileData.customerName || '-' }}
              </div>
            </ng-template>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Role Description</mat-label>
            <textarea matInput *ngIf="operation !== 'view'" [(ngModel)]="profileData.description" [ngModelOptions]="{standalone:true}"
              placeholder="Write role description..." name="description" id="" rows="4"></textarea>
            <textarea matInput readonly="" *ngIf="operation === 'view'">{{profileData.description
              || '-'}}</textarea>
          </mat-form-field>



        </div>
      </div>


      <div class="d-flex justify-content-end gap-2">
        <button type="button" mat-raised-button (click)="navigateToProfilesList()">Cancel</button>
        <button type="submit" mat-raised-button color="primary" *ngIf="title !== 'view' && title != 'edit'"
          [disabled]="isFormNotValid || !profileData['selectedApplication'] || isRoleNameNotValid"
          (click)="onFormSubmit(f)">Continue</button>
        <button type="submit" mat-raised-button color="primary" *ngIf="title !== 'view' && title == 'edit'"
          (click)="update()">Update</button>

      </div>



    </form>
  </mat-step>
  <mat-step label="Assign Resources" >

    <div class="card card-resource-container table-primary">
      <!-- <spinner [id]="'role-resource-data'" [show]='loading'></spinner> -->
      <div class="card-header">
        <h2 class="m-0 card-title">{{profileData.applicationName}}</h2>
      </div>
      <div class="card-body p-0">
        <div class="resource-container">
          <!-- Apis -->
          <div class="resource-col">
            <div class="resource-header">
              <div class="header-start">
                <h5 class="title">API's</h5>
              </div>
              <div class="header-end">
                <div class="input-group input-group-sm input-group-search">
                  <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
                  <input type="text" class="form-control" placeholder="Search for API" [(ngModel)]="searchApi">
                </div>
              </div>
            </div>
            <div class="resource-body">
              <ng-container *ngIf="resourceList && resourceList['APIs']">
                <div class="body-header mb-2" *ngIf="resourceList['APIs'].length > 0 && operation !== 'view'">
                  <a mat-button (click)="selectAll('APIs',searchApi)">Select All</a>
                  <a mat-button (click)="clearAll('APIs',searchApi)">Clear All</a>
                </div>
                <div class="d-flex flex-wrap gap-2">
                  <ng-container
                    *ngFor="let item of resourceList['APIs'] | filter: searchApi let i = index;let even = even">
                    <ng-container *ngFor="let action of item['actionsInfo'] let j = index;">
                      <button mat-raised-button [matTooltip]="item.resourceName.length > 40 ? item.resourceName : ''" [title]="item.resourceName | truncate : 40" 
                        (click)="resourceToggle('APIs', item.resourceId, action.actionId)" 
                        [class.accent]="action.isAssigned ? 'accent' : ''"
                        [disabled]="operation == 'view'"
                        class="h-auto lh-base p-2">
                        <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[action.actionName]}})</span>
                      </button>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
              <div *ngIf="!resourceList || !resourceList['APIs'] ||resourceList['APIs'].length === 0" class="no-data">
                No APIs to display
              </div>



            </div>
          </div>
          <!-- Urls -->
          <div class="resource-col">
            <div class="resource-header">
              <div class="header-start">
                <h5 class="title">URL’s</h5>
              </div>
              <div class="header-end">
                <div class="input-group input-group-sm input-group-search">
                  <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
                  <input type="text" class="form-control" placeholder="Search for URL’s" [(ngModel)]="searchUrl">
                </div>
              </div>
            </div>
            <div class="resource-body">
              <ng-container *ngIf="resourceList && resourceList['URLs']">
                <div class="body-header mb-2" *ngIf="resourceList['URLs'].length > 0 && operation !== 'view'">
                  <a mat-button (click)="selectAll('URLs',searchUrl)">Select All</a>
                  <a mat-button (click)="clearAll('URLs',searchUrl)">Clear All</a>
                </div>
                <div class="d-flex flex-wrap gap-2" >
                  <ng-container
                    *ngFor="let item of resourceList['URLs'] | filter: searchUrl let i = index;let even = even">
                    <ng-container *ngFor="let action of item['actionsInfo'] let j = index;">
                      <button mat-raised-button  [matTooltip]="item.resourceName.length > 40 ? item.resourceName : ''" [title]="item.resourceName | truncate : 40"
                        (click)="resourceToggle('URLs', item.resourceId, action.actionId)" 
                        [class.accent]="action.isAssigned ? 'accent' : ''"
                        [disabled]="operation == 'view'"
                        class="h-auto lh-base p-2">
                        <span class="text-black">{{item.resourceName | capitalizeFirst}} ({{actionNameMapping[action.actionName]}})</span>
                      </button>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
              <div *ngIf="!resourceList || !resourceList['URLs'] ||resourceList['URLs'].length === 0" class="no-data">
                No URLs to display
              </div>
            </div>
          </div>
          <!-- Dashboard -->
          <div class="resource-col">
            <div class="resource-header">
              <div class="header-start">
                <h5 class="title">Dashboard</h5>
              </div>
              <div class="header-end">
                <div class="input-group input-group-sm input-group-search">
                  <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
                  <input type="text" class="form-control" placeholder="Search for Dashboard" [(ngModel)]="searchDashboard" (ngModelChange)="toggleAllPanels('Dashboards','opened')">
                </div>
              </div>
            </div>
            <div class="resource-body">
              <ng-container *ngIf="resourceList && resourceList['Dashboards']">
                <div class="body-header mb-2 d-flex gap-2" *ngIf="resourceList['Dashboards'].length > 0 && operation !== 'view'">
                  <a mat-button (click)="selectAll('Dashboards',searchDashboard)">Select All</a>
                  <a mat-button (click)="clearAll('Dashboards',searchDashboard)">Clear All</a>
                  <span class="flex-fill"></span>
                  @if(!(resourceList['Dashboards']?.length >= 1 && resourceList['Dashboards'][0].resourceId)){
                    <a mat-button *ngIf="expandAllDashboards === 'closed'" (click)="toggleAllPanels('Dashboards','opened')">Expand All</a>
                   <a mat-button *ngIf="expandAllDashboards === 'opened'" (click)="toggleAllPanels('Dashboards','closed')">Close All</a>
                  }

                </div>
                @if(resourceList['Dashboards'].length >= 1 && resourceList['Dashboards'][0].resourceId) {
                    <div class="d-flex flex-wrap gap-2">
                      <ng-container *ngFor="let item of resourceList['Dashboards'] | filter: searchDashboard let i = index;let even = even">
                        <ng-container *ngFor="let action of item['actionsInfo'] let j = index;">
                          <button mat-raised-button [matTooltip]="item.resourceName.length > 40 ? item.resourceName : ''" [title]="item.resourceName | truncate : 40"
                            (click)="resourceToggle('Dashboards', item.resourceId, action.actionId)"
                            [class.accent]="action.isAssigned ? 'accent' : ''" class="h-auto lh-base p-2" [disabled]="operation == 'view'">
                            <span class="text-black">{{item.resourceName | capitalizeFirst}}
                              ({{actionNameMapping[action.actionName]}})</span>
                          </button>
                        </ng-container>
                      </ng-container>
                    </div>
                } @else {
                  <div class="accordion w-100">
                    <ng-container *ngFor="let resource of resourceList['Dashboards']; " >
                    
                      <!-- Only show if filtered pages and forms are available -->
                      <div class="panel mb-2" *ngIf="getFilteredDashboardsPages(resource, searchDashboard).length > 0 && getFilteredDashboardsForms(resource, searchDashboard).length > 0">
                    
                        <!-- Accordion Header -->
                        <div class="panel-header d-flex justify-content-between align-items-center p-2"
                          (click)="resource.expanded = !resource.expanded" style="cursor:pointer; user-select:none;">
                    
                          <span class="flex-fill fw-400" >
                            {{ resource.page_name | titlecase | truncate:40 }}
                          </span>
                    
                          <span>
                            <span class="chip">
                              {{ ((resource.forms?.length || 0) + (resource.pages?.length || 0)) * 2 }}
                            </span>
                          </span>
                        </div>
                    
                        <!-- Accordion Content -->
                        <div class="panel-content" [hidden]="!resource.expanded" style="padding: 0 1rem 1rem 1rem;">
                    
                          <div class="actions mt-2 mb-2" *ngIf="operation !== 'view'">
                            <a class="action-link" (click)="selectAllInResource(resource, searchWidget)">Select All</a>
                            <a class="action-link ms-3" (click)="clearAllInResource(resource, searchWidget)">Clear All</a>
                            <hr class="mt-2 mb-2" />
                          </div>
                    
                          <!-- Pages Section -->
                          <div>
                            <div class="fw-400 mb-1 ms-2">Page</div>
                            <ng-container *ngIf="resource.pages?.length; else noResources">
                              <div class="d-flex flex-wrap gap-2 ms-2">
                                <ng-container *ngFor="let resourceItem of resource.pages | filter: searchDashboard; ">
                                  <ng-container *ngFor="let action of resourceItem.actionsInfo; let j = index">
                                    <button  mat-raised-button [matTooltip]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''"
                                      [title]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''"
                                      (click)="resourceToggle('Dashboards', resourceItem.resourceId, action.actionId, resourceItem)"
                                       [class.accent]="action.isAssigned ? 'accent' : ''" [disabled]="operation === 'view'">
                                      {{ resourceItem.resourceName | capitalizeFirst | truncate: 40 }} ({{ actionNameMapping[action.actionName] }})
                                    </button>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </ng-container>
                          </div>
                    
                          <!-- Forms Section -->
                          <div>
                            <div class="fw-400 my-2 ms-2">Forms</div>
                            <ng-container *ngIf="resource.forms?.length; else noResources">
                              <div class="d-flex flex-wrap gap-2 ms-2">
                                <ng-container *ngFor="let resourceItem of resource.forms | filter: searchDashboard;">
                                  <ng-container *ngFor="let action of resourceItem.actionsInfo; let j = index">
                                    <button  mat-raised-button [matTooltip]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''"
                                      [title]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''"
                                      (click)="resourceToggle('Dashboards', resourceItem.resourceId, action.actionId, resourceItem)"
                                      [class.accent]="action.isAssigned" [disabled]="operation === 'view'">
                                      {{ resourceItem.resourceName | capitalizeFirst | truncate : 40 }} ({{ actionNameMapping[action.actionName] }})
                                    </button>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </ng-container>
                          </div>
                    
                        </div>
                      </div>
                    
                    </ng-container>
                    
                    <ng-template #noResources>
                      <p class="p-2 text-muted">No resource available</p>
                    </ng-template>
                    </div>
                         
                  }
              </ng-container>
              <div *ngIf="!resourceList || !resourceList['Dashboards'] ||resourceList['Dashboards'].length === 0" class="no-data">
                  No Dashboards to display
              </div>
            </div>
          </div>

          <div class="resource-col">
            <div class="resource-header">
              <div class="header-start">
                <h5 class="title">Widget</h5>
              </div>
              <div class="header-end">
                <div class="input-group input-group-sm input-group-search">
                  <span class="input-group-text"><i class='mdi mdi-magnify'></i></span>
                  <input type="text" class="form-control" placeholder="Search for Widget" [(ngModel)]="searchWidget" (ngModelChange)="toggleAllPanels('Widgets','opened')">
                </div>
              </div>
            </div>
            <div class="resource-body">
              <ng-container *ngIf="resourceList && resourceList['Widgets']">
                <div class="body-header mb-2 d-flex gap-2" *ngIf="resourceList['Widgets'].length > 0 && operation !== 'view'">
                  <a mat-button  (click)="selectAll('Widgets',searchWidget);">Select All</a>
                  <a mat-button (click)="clearAll('Widgets',searchWidget)" >Clear All</a>
                   <span class="flex-fill"></span>
                   @if(!(resourceList['Widgets']?.length >= 1 && resourceList['Widgets'][0].resourceId)){
                     <a mat-button *ngIf="expandAllWidgets === 'closed'" (click)="toggleAllPanels('Widgets','opened')">Expand All</a>
                    <a mat-button *ngIf="expandAllWidgets === 'opened'" (click)="toggleAllPanels('Widgets','closed')">Close All</a>
                   }
                </div>
                 @if(resourceList['Widgets'].length >= 1 && resourceList['Widgets'][0].resourceId) {
                    <div class="d-flex flex-wrap gap-2">
                      <ng-container *ngFor="let item of resourceList['Widgets'] | filter: searchWidget let i = index;let even = even">
                        <ng-container *ngFor="let action of item['actionsInfo'] let j = index;">
                          <button mat-raised-button [matTooltip]="item.resourceName.length > 40 ? item.resourceName : ''" 
                            (click)="resourceToggle('Widgets', item.resourceId, action.actionId)"
                            [class.accent]="action.isAssigned ? 'accent' : ''" class="h-auto lh-base p-2" [disabled]="operation == 'view'">
                            {{item.resourceName | capitalizeFirst | truncate: 40}}
                              ({{actionNameMapping[action.actionName]}})
                          </button>
                        </ng-container>
                      </ng-container>
                    </div>
                } @else {
                 <div class="accordion w-100">
                  <ng-container *ngFor="let resource of resourceList['Widgets'];" >
                    <!-- Show panel only if filtered widgets exist -->
                    <div class="panel mb-2" *ngIf="getFilteredWidgets(resource, searchWidget).length > 0">
                      <!-- Panel header with toggle -->
                      <div class="panel-header d-flex justify-content-between align-items-center p-2"
                        (click)="resource.expanded = !resource.expanded" style="cursor: pointer; user-select: none;">
                        <span class="flex-fill fw-400" [title]="resource.page_name.length > 40 ? resource.page_name : ''">
                          {{ resource.page_name | titlecase | truncate : 40 }}
                        </span>
                        <span>
                          <span class="chip">
                            {{ (resource.Widgets?.length || 0) * 2 }}
                          </span>
                        </span>
                      </div>
                  
                      <!-- Panel content -->
                      <div class="panel-content" [hidden]="!resource.expanded" style="padding: 0 1rem 1rem 1rem;">
                  
                        <div class="actions mb-2" *ngIf="operation !== 'view'">
                          <a class="action-link me-3"  (click)="selectAllInResource(resource, searchWidget)">Select All</a>
                          <a class="action-link" (click)="clearAllInResource(resource, searchWidget)">Clear All</a>
                          <hr class="mt-1 mb-1" />
                        </div>
                  
                        <ng-container *ngIf="resource.Widgets?.length; else noResources">
                          <div class="d-flex flex-wrap gap-2 ms-2">
                            <ng-container *ngFor="let resourceItem of resource.Widgets | filter: searchWidget; ">
                              <ng-container *ngFor="let action of resourceItem.actionsInfo; let j = index;">
                                <button mat-raised-button [matTooltip]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''" 
                                  [title]="resourceItem.resourceName.length > 40 ? resourceItem.resourceName : ''"
                                  (click)="resourceToggle('Widgets', resourceItem.resourceId, action.actionId, resourceItem)"
                                  [class.accent]="action.isAssigned" [disabled]="operation === 'view'">
                                  {{ resourceItem.resourceName | capitalizeFirst | truncate : 40 }} ({{
                                    actionNameMapping[action.actionName] }})
                                </button>
                              </ng-container>
                            </ng-container>
                          </div>
                        </ng-container>
                  
                      </div>
                  
                    </div>
                  </ng-container>
                  
                  <ng-template #noResources>
                    <p class="p-2 text-sm text-muted">No resource available</p>
                  </ng-template>
                  </div>
                           
                  }
              </ng-container>
              <div *ngIf="!resourceList || !resourceList['Widgets'] ||resourceList['Widgets'].length === 0" class="no-data">
                  No Widgets to display
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-2">
      <button mat-raised-button type="button" (click)="navigateToProfilesList()">Cancel</button>
      <button mat-raised-button type="submit" color="primary" *ngIf="operation !== 'view'"
      (click)="update()">{{title == 'edit'? 'Update': 'Continue'}}</button>
  </div>
  </mat-step>
  <mat-step label="Role Scope">
    <app-role-valid-scope [disabled]="operation === 'view'" [application]="profileData.selectedApplication"
      [scopeEndPoint]="scopeEndPoint" [initScope]="initScope"
      (onScopeUpdate)="updateScope($event)" (isValidScope)="checkValidScope($event)"></app-role-valid-scope>
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button mat-raised-button  type="button"  (click)="navigateToProfilesList()">Cancel</button>
      <button mat-raised-button type="submit" color="primary" [disabled]="isScopeValid" *ngIf="operation !== 'view'"
        (click)="update()">{{operation == 'edit'? 'Update': 'Save'}}</button>
    </div>
  </mat-step>
</mat-stepper>